import { Component, OnDestroy, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { APP_CONSTANTS } from '../../constants/enum.constants';
import { AuthService } from '../../services/auth.service';
import { WebsocketService } from '../../services/websocket.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/core/services/toast.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ConfirmPopupComponent } from 'src/app/standalone/components/confirm-popup/confirm-popup.component';
import { isPlatformBrowser } from '@angular/common';

declare let fbq: Function;

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html'
})
export class ShellComponent implements OnInit, OnDestroy {
    isDarkModeEnabled = false;
    isLoggedIn!: boolean;
    subscriptions: Subscription[] = [];

    private http = inject(HttpClient);
    private websocket = inject(WebsocketService);
    private authService = inject(AuthService);
    private toastService = inject(ToastService);
    private ngbModel = inject(NgbModal);
    private platformId = inject(PLATFORM_ID);

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            const socketStatusSub: Subscription = this.websocket.socketStatusObs.subscribe({
                next: response => {
                    if (response) this.websocket.joinRoom(APP_CONSTANTS.COIN_PRICE_ROOM);
                }
            });
            this.subscriptions.push(socketStatusSub);
        }

        /* Subscribe to the AuthStatus Observable to get the Latest User Auth Status */
        const authSub: Subscription = this.authService.authStatusObs.subscribe({
            next: response => (this.isLoggedIn = response)
        });
        this.subscriptions.push(authSub);
    }

    onActivate() {
        if (isPlatformBrowser(this.platformId)) window.scrollTo(0, 0);
    }

    onLogout() {
        this.ngbModel.dismissAll();
        const modalRef: NgbModalRef = this.ngbModel.open(ConfirmPopupComponent, {
            backdrop: true,
            size: 'sm',
            centered: true
        });
        modalRef.componentInstance.data = {
            title: 'CONFIRMATION.LOGOUT.TITLE',
            message: 'CONFIRMATION.LOGOUT.MESSAGE'
        };
        modalRef.result.then(result => {
            if (result) this.authService.logout();
        });
    }

    onSubscribe(email: string) {
        const payload = {
            email: email,
            flag: 1
        };
        this.http
            .post<{ message: string; status: number; data: { is_subscribed: boolean } }>(
                `${environment.IXFI_API}auth/subscribe-newsletter`,
                payload
            )
            .subscribe({
                next: response => {
                    if (response.status === 200) {
                        this.toastService.open({
                            toastType: 'success',
                            toastMessage: response.message
                        });
                        if (!response.data.is_subscribed && environment.production) fbq('track', 'Lead');
                    } else {
                        this.toastService.open({
                            toastType: 'error',
                            toastMessage: response.message
                        });
                    }
                }
            });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        if (isPlatformBrowser(this.platformId)) {
            /**
             * Web socket Connections are made only in the client so check for browser
             * Shell component acts as a shell for the whole application
             * so disconnect from the coinPrice room and also disconnect socket connection
             */
            this.websocket.disconnectFromRoom(APP_CONSTANTS.COIN_PRICE_ROOM);
            this.websocket.disconnectSocket();
        }
    }
}
